import { KamiVisibility } from "../enumerations";

export interface SimpleClient {
	clientId: number,
  clientName: string,
  trial: boolean,
  attachReport: boolean,
  mavScanner?: boolean,
  kami_visibility?: KamiVisibility,
  kami_notification_emails?: string,
  kami_global_email_delay?: number
}